import * as o from "react";
import c from "../lib/IconBase.es.js";
import e from "../defs/Factory.es.js";
const r = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(c, { ref: a, ...t, weights: e }));
r.displayName = "FactoryIcon";
const n = r;
export {
  n as Factory,
  r as FactoryIcon
};
